import AudioDescribedIcon from 'assets/icons/audio-described.svg';
import SignLanguageInterpretedIcon from 'assets/icons/sign-language.svg';
import SpaLink from 'components/SpaLink/SpaLink';
import styles from './AnchorTag.module.css';
const getIcon = (versionName: string) => {
  switch (versionName) {
    case 'AUDIO_DESCRIPTION':
      return <AudioDescribedIcon className={styles.versionIcon} />;
    case 'SIGN_LANGUAGE':
      return <SignLanguageInterpretedIcon className={styles.versionIcon} />;
    default:
      return null;
  }
};
interface AnchorTagProps {
  link: string;
  versionName: string;
  text: string;
}
const AnchorTag = ({
  link,
  versionName,
  text
}: AnchorTagProps) => {
  return <SpaLink href={`${link}`} key={versionName} className={styles.versionLink} data-sentry-element="SpaLink" data-sentry-component="AnchorTag" data-sentry-source-file="AnchorTag.tsx">
      {getIcon(versionName)}
      {text}
    </SpaLink>;
};
export default AnchorTag;